<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form ref="form" label-width="120px" :model="dataForm">
        <el-form-item label="内容标题：">
          {{ dataForm.Title }}
        </el-form-item>

        <el-form-item label="文章分类：">
          {{ typeName }}
        </el-form-item>

        <el-form-item label="封面图：">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPicPreview"
            :fileList="pictureList"
            :class="{ hidePic: true }"
          >
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item label="摘要：">
          {{ dataForm.Describe }}
        </el-form-item>

        <el-form-item label="作者：">
          {{ dataForm.Publisher }}
        </el-form-item>
        <el-form-item label="来源：">
          {{ dataForm.PublishSource }}
        </el-form-item>
        <el-form-item label="排序号：">
          {{ dataForm.Sort }}
        </el-form-item>
        <el-form-item label="上传附件：">
          <of-upload
            class="upload-demo"
            list-type="fileList"
            @onPreview="onFilePreview"
            :fileList="fileList"
            :class="{ hideFile: true }"
          >
          </of-upload>
        </el-form-item>
        <el-form-item label="内容：">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
            :isEdit="true"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      dialogVisible: false,
      dialogImageUrl: "",
      pictureList: [], //图片数组
      fileList: [], //附件数组
      width: "70%",
      typeName:"",//分类名称
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
    OfTinymce,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    let that = this;
    that.getJstreeNodes();
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryNewsById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getJstreeNodes();
          that.getImg();
          that.getlistfile();
        }
      });
    },
    //加载菜单
    getJstreeNodes() {
      let that=this;
      api.QueryNewsType().then((res) => {
        if (res.data.Code == 0) {
          var options = res.data.Data;
          that.getTypeName(options);
        }
      });
    },
     //文章分类
    getTypeName(option) {
      let that=this;
      option.forEach((item, index) => {
        if (item.id == that.dataForm.TypeId) {
          that.typeName = item.text;
        } else if (item.children != null && item.children.length > 0) {
          that.getTypeName(item.children);
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditNews(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //加载图片
    getImg() {
      if (
        this.dataForm.HeadImage === undefined ||
        this.dataForm.HeadImage === null
      ) {
        return;
      }
      this.$http.get(this.dataForm.HeadImage).then((res) => {
        let pictureList = [res.config];
        this.pictureList = pictureList.map((item) => {
          return {
            url: item.url,
          };
        });
      });
    },
    //加载文件
    getlistfile() {
      if (this.dataForm.File === undefined || this.dataForm.File === null) {
        return;
      }
      this.fileList = JSON.parse(this.dataForm.File);
    },
    onPicPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hidePic >>> .el-upload-list__item-delete {
  display: none !important;
}
.hidePic >>> .el-icon-close {
  display: none !important;
}
.hidePic >>> .el-icon-close-tip {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>